export default __webpack_public_path__ + "static/media/p8.a7a89f4f.jpg";